/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Solution.css';
import banner from './banner.png';
import Link from './../../components/Link'
import Model from './../../components/Model'

// import Calendar from '../../components/Calendar'

class Solution extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired
  };


  constructor(){
    super()
    this.state={
      isShowModel:false
    }
    this.changeShow=this.changeShow.bind(this)
    this.close=this.close.bind(this)
  }

  changeShow=()=>{
    this.setState({isShowModel:true})
  }
  close=()=>{
    this.setState({isShowModel:false})
  }

  render() {
    return (
      <div className={s.root}>
        <div className={s.imgBox}>

          <div className={s.banner}>
            <img src={banner} />
          </div>
        </div>
        {/* <Calendar/> */}



        <div className={s.solutionItem}>
          <div className={s.content}>
            <div className={s.itemImg1}></div>
            <div className={s.itemTxt}>
              <h2 className={s.h2Tit}>品牌军情室</h2>
              <span className={s.h2En}>Dashboard</span>
              <ul className={s.infoList}>
                <li>识别品牌自身在社交平台上的受众口碑真实状况</li>
                <li>查看传播战役实际战果</li>
                <li>发现关键事件和KOL</li>
              </ul>
              {/* <p className={s.info}>识别品牌自身在社交平台上的受众口碑真实状况，查看传播战役实际战果，</p>
              <p className={s.info}>发现关键事件和KOL</p> */}
              <Link to='/dashboard' className={s.Btn}>立即试用</Link>
            </div>
          </div>
        </div>
        <div className={s.solutionItem2}>
          <div className={s.content}>
            <div className={s.itemImg2}></div>
            <div className={s.itemTxt2}>
              <h2 className={s.h2Tit2}>心智占有率</h2>
              <span className={s.h2En2}>Mindshare</span>
              <ul className={s.infoList}>
                <li>直观呈现品牌在细分领域中的受众心智占有份额</li>
                <li>支持自由选择添加竞品进行比较</li>
              </ul>
              {/* <p className={s.info2}>直观呈现品牌在细分领域中的受众心智占有份额；支持自由选择添加竞品进行比较</p> */}
              <Link to='/dashboard?brandName=腾讯,阿里巴巴' className={s.Btn}>立即试用</Link>
            </div>
          </div>
        </div>
        <div className={s.solutionItem}>
          <div className={s.content}>
            <div className={s.itemImg3}></div>
            <div className={s.itemTxt}>
              <h2 className={s.h2Tit}>轻度定制</h2>
              <span className={s.h2En}>Customization</span>
              <ul className={s.infoList}>
                <li>品牌关键词云分析</li>
                <li>关联KOL名单轻松掌握</li>
                <li>自由监测更多竞品</li>
                <li>全行业机会洞察和趋势分析</li>
                <li>传播策略咨询与创意策划</li>
              </ul>
              <span onClick={this.changeShow} className={s.Btn} >联系我们</span>
            </div>
          </div>
        </div>
        <div className={s.solutionItem2}>
          <div className={s.content}>
            <div className={s.itemImg4}></div>
            <div className={s.itemTxt2}>
              <h2 className={s.h2Tit2}>深度定制</h2>
              <span className={s.h2En2}>Advanced Customization</span>
              <ul className={s.infoList}>
                <li>特定事件专项分析</li>
                <li>特定时段竞品演化对比</li>
                <li>特定人群画像与数据挖掘</li>
                <li>特定需求专项定制服务</li>
                <li>智库专家新媒体战略咨询</li>
              </ul>
              <span onClick={this.changeShow} className={s.Btn} >联系我们</span>
            </div>
          </div>
        </div>
        <Model isShow={this.state.isShowModel} close={this.close}/>

      </div>
    );
  }
}

export default withStyles(s)(Solution);



// WEBPACK FOOTER //
// src/routes/solution/Solution.js